import { render } from "./SidebarItem.vue?vue&type=template&id=46054d1d&ts=true"
import script from "./SidebarItem.vue?vue&type=script&lang=ts"
export * from "./SidebarItem.vue?vue&type=script&lang=ts"

import "./SidebarItem.vue?vue&type=style&index=0&id=46054d1d&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__